/**
 * NOTE: Move to masterDateSlice.ts
 */

import {PayloadAction, createSlice} from '@reduxjs/toolkit'
import {IGetPriceJbpSearchParams} from '../../api/modules/master-data/types'
import {RootState} from '../../store'

interface IFilterJBP extends IGetPriceJbpSearchParams {}

export interface IPriceState {
  filterJBP: IFilterJBP
}

const initialState: IPriceState = {
  filterJBP: {
    sales_org_code2: '',
    sales_org_code: '',
    customer_code: '',
    customer_name: '',
    product_code: '',
    product_name: '',
    region_name: '',
    city_name: '',
    is_active: '',
    selling_price: '',
    minimum_price: '',
    discount: '',
    purchase_price: '',
    type: '',
    description: '',
    per_page: 25,
  },
}

/**
 * Slices
 */
const priceSlice = createSlice({
  name: 'price',
  initialState,
  reducers: {
    setFilterJBP: (state: IPriceState, action: PayloadAction<IFilterJBP>) => {
      state.filterJBP = action.payload
    },
    resetFilterJBP: (state: IPriceState) => {
      state.filterJBP = initialState.filterJBP
    },
  },
})

/**
 * Actions
 */
export const {setFilterJBP, resetFilterJBP} = priceSlice.actions

/**
 * Selector
 */
export const priceSelector = (state: RootState) => state.priceReducer

/**
 * Reducer
 */
export default priceSlice.reducer
